import { useEffect, useState } from 'react';
import { ACSApi } from '../../../api';
import { LeaveRequestUserInfoIncluded } from '../../../commonTypes/acs';
import { useContainer } from '../../useContainer';

const useHttpGetAllLeaveRequestsByOrganizationIdForExport = (organizationId: string) => {
    const acsApi = useContainer(ACSApi);

    const [data, setData] = useState<LeaveRequestUserInfoIncluded[]>([]);
    const [isReady, setReady] = useState(false);

    const { exec, abort } = acsApi.getAllLeaveRequestsAndUsersByOrganizationId({
        params: { organizationId },
        onSuccess: res => {
            setData(res.body);
        },
        onError: error => {
            console.error('Error fetching leave requests:', error);
        },
        onFinally: () => setReady(true),
    });

    useEffect(() => {
        if (!organizationId) return;
        exec();
        return abort;
    }, [organizationId, exec, abort]);

    return { exec, abort, data, setData, isReady };
};

export default useHttpGetAllLeaveRequestsByOrganizationIdForExport;
